// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"70bf1b91","137":"f9b8c83f","238":"91d33477","365":"e2d6af72","512":"73a85ca9","670":"386a69f8","710":"bce1397c","787":"c28d1b22"}[chunkId] + ".chunk.js";
};